module.exports = __webpack_public_path__ + "img/logo-salesbox.14701a93.svg";